import { render, staticRenderFns } from "./StripePaymentElement.vue?vue&type=template&id=38375bee&"
import script from "./StripePaymentElement.vue?vue&type=script&lang=ts&"
export * from "./StripePaymentElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports